import Swal from "sweetalert2";
import { AuthService } from "../services/AuthService.js";
import { SupportService } from "../services/SupportService.js";

function escape(v) {
	return String(v ?? "").replace(/"/g, "&quot;");
}

export const SupportDialog = {
	open: async () => {
		const user = AuthService.getCurrentUser();
		const prefill = {
			nombres: user?.nombre || user?.nombres || "",
			documento: user?.documento || "",
			email: user?.email || user?.mail || "",
			celular: user?.celular || "",
		};

		const html = `
			<form id="supportForm" class="text-start">
				<p class="text-muted small mb-3">Completá al menos uno de los datos de contacto para que podamos responderte.</p>
				<div class="row g-2">
					<div class="col-sm-6 mb-2">
						<label class="form-label small mb-1">Nombres</label>
						<input type="text" class="form-control" id="sup_nombres"
							placeholder="Tu nombre" value="${escape(prefill.nombres)}">
					</div>
					<div class="col-sm-6 mb-2">
						<label class="form-label small mb-1">Documento</label>
						<input type="text" class="form-control" id="sup_documento"
							placeholder="DNI / CUIT" value="${escape(prefill.documento)}">
					</div>
				</div>
				<div class="row g-2">
					<div class="col-sm-6 mb-2">
						<label class="form-label small mb-1">Email</label>
						<input type="email" class="form-control" id="sup_email"
							placeholder="tu@email.com" value="${escape(prefill.email)}">
					</div>
					<div class="col-sm-6 mb-2">
						<label class="form-label small mb-1">Celular</label>
						<input type="tel" class="form-control" id="sup_celular"
							placeholder="Celular de contacto" value="${escape(prefill.celular)}">
					</div>
				</div>
				<div class="mb-2">
					<label class="form-label small mb-1">Dominio del vehículo (opcional)</label>
					<input type="text" class="form-control text-uppercase" id="sup_dominio"
						placeholder="Ej: AB123CD" maxlength="7">
				</div>
				<div class="mb-1">
					<label class="form-label small mb-1">Detalle del problema *</label>
					<textarea class="form-control" id="sup_detalle" rows="4"
						placeholder="Contanos qué estás necesitando..."></textarea>
				</div>
			</form>
		`;

		const result = await Swal.fire({
			title: '<i class="fas fa-headset me-2"></i>Soporte',
			html,
			width: 520,
			showCancelButton: true,
			confirmButtonText: "Enviar",
			cancelButtonText: "Cancelar",
			focusConfirm: false,
			preConfirm: () => {
				const nombres = document.getElementById("sup_nombres").value.trim();
				const documento = document.getElementById("sup_documento").value.trim();
				const email = document.getElementById("sup_email").value.trim();
				const celular = document.getElementById("sup_celular").value.trim();
				const dominio = document.getElementById("sup_dominio").value.trim().toUpperCase();
				const detalle = document.getElementById("sup_detalle").value.trim();

				if (!nombres && !documento && !email && !celular) {
					Swal.showValidationMessage("Completá al menos un dato de contacto");
					return false;
				}
				if (!detalle) {
					Swal.showValidationMessage("Describí el problema");
					return false;
				}

				return { nombres, documento, email, celular, dominio, detalle };
			},
		});

		if (!result.isConfirmed || !result.value) return;

		try {
			Swal.fire({
				title: "Enviando...",
				allowOutsideClick: false,
				didOpen: () => Swal.showLoading(),
			});

			const resp = await SupportService.enviarPedido(result.value, user?.token);

			if (resp?.status === 0 || resp?.status > 0 || resp?.success) {
				await Swal.fire({
					icon: "success",
					title: "¡Gracias!",
					text: "En breve te estaremos contactando para brindarte respuesta.",
					confirmButtonText: "Aceptar",
				});
			} else {
				await Swal.fire({
					icon: "error",
					title: "Error",
					text: resp?.message || "No pudimos enviar tu pedido. Intentá nuevamente.",
				});
			}
		} catch (err) {
			console.error("Error enviando soporte:", err);
			await Swal.fire({
				icon: "error",
				title: "Error",
				text: "No pudimos enviar tu pedido. Revisá tu conexión e intentá nuevamente.",
			});
		}
	},
};
